module.exports = __webpack_public_path__ + "media/images/story/top/point_1-b92114c674da16c75b427e4d3947f9fc.svg";